"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XDB = void 0;
const localforage_1 = __importDefault(require("localforage"));
const XEvent_1 = require("../../XEvent");
class XDB {
    constructor() {
        this._Queue = [];
    }
    static get Inst() {
        if (!this._Inst) {
            this._Inst = new XDB();
        }
        return this._Inst;
    }
    async Init() {
        await localforage_1.default.ready();
        window.localforage = localforage_1.default;
        XEvent_1.XEvent.Ins.On("ImageLoaded", this.StoreImage.bind(this));
        XEvent_1.XEvent.Ins.On("TxtLoaded", this.StoreText.bind(this));
    }
    async _Store(aTable, aData) {
        const found = localStorage.getItem(aData.id);
        if (!found) {
            localStorage.setItem(aData.id, "true");
            await localforage_1.default.setItem(aData.id, {
                data: aData.data,
                metaData: aData.metadata,
            });
        }
    }
    StorPlist(aData) {
        return this._Store("Plist", aData);
    }
    async StoreImage(aData) {
        const lCanvas = document.createElement("canvas");
        if (!aData.img?.width) {
            console.log("Image not loaded", aData.url);
            return;
        }
        lCanvas.width = aData.img.width;
        lCanvas.height = aData.img.height;
        const lCtx = lCanvas.getContext("2d");
        // scale * 2 the image before drawing it to the canvas
        lCtx.drawImage(aData.img, 0, 0);
        const lData = lCanvas.toDataURL("image/png");
        return this._Store("Image", {
            id: aData.url,
            data: lData,
            metadata: {
                width: aData.img.width,
                height: aData.img.height,
                nWidth: aData.img.width * 2,
                nHeight: aData.img.height * 2,
                imageName: aData.url,
            }
        });
    }
    async StoreText(aData) {
        return this._Store("Txt", {
            id: aData.url,
            data: aData.txt,
        });
    }
    StoreJson(aData) {
        return this._Store("Json", aData);
    }
    async _Get(aTable, aID) {
        return (await localforage_1.default.getItem(aID))?.data;
    }
    GetJson(aID) {
        return this._Get("Json", aID);
    }
    GetPlist(aID) {
        return this._Get("Plist", aID);
    }
    async GetImage(aID) {
        if (aID.indexOf(".png") < 0) {
            return null;
        }
        const lImg = await this._Get("Image", aID);
        if (!lImg)
            return null;
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = lImg;
            // img.onload = () => {
            //   resolve(img);
            // };
            img.addEventListener("load", () => {
                resolve(img);
            });
            img.onerror = () => {
                console.error("Image Load Error", aID);
                reject();
            };
        });
    }
    async GetText(aID) {
        const lTxt = await this._Get("Txt", aID);
        return lTxt;
    }
}
exports.XDB = XDB;
XDB.aDBName = "AlQaher";
XDB.aDBVersion = 1;
XDB.aDBTables = ["Json", "Plist", "Image"];
window.XDB = XDB;
